export default __webpack_public_path__ + "static/media/Realizations.5115b80c.png";